// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contenedor {
    height: 100vh;
}

.scrollable {
    max-height: 100vh; /* Ajusta esta altura según tus necesidades */
    overflow-y: scroll;
}

.scrollable::-webkit-scrollbar {
    width: 8px; /* Ancho del scroll */
}

.scrollable::-webkit-scrollbar-thumb {
    background-color: rgba(100, 100, 100, 0.5); /* Color del scroll */
    border-radius: 10px; /* Redondeo del scroll */
}

.scrollable::-webkit-scrollbar-thumb:hover {
    background-color: rgba(100, 100, 100, 0.7); /* Color al pasar el cursor */
}

.scrollable::-webkit-scrollbar-track {
    background: transparent; /* Fondo del track del scroll */
}


.dropdown-item {
    color: #000000 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/programas/config-avanzada/config-avanzada.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB,EAAE,6CAA6C;IAChE,kBAAkB;AACtB;;AAEA;IACI,UAAU,EAAE,qBAAqB;AACrC;;AAEA;IACI,0CAA0C,EAAE,qBAAqB;IACjE,mBAAmB,EAAE,wBAAwB;AACjD;;AAEA;IACI,0CAA0C,EAAE,6BAA6B;AAC7E;;AAEA;IACI,uBAAuB,EAAE,+BAA+B;AAC5D;;;AAGA;IACI,yBAAyB;AAC7B","sourcesContent":[".contenedor {\n    height: 100vh;\n}\n\n.scrollable {\n    max-height: 100vh; /* Ajusta esta altura según tus necesidades */\n    overflow-y: scroll;\n}\n\n.scrollable::-webkit-scrollbar {\n    width: 8px; /* Ancho del scroll */\n}\n\n.scrollable::-webkit-scrollbar-thumb {\n    background-color: rgba(100, 100, 100, 0.5); /* Color del scroll */\n    border-radius: 10px; /* Redondeo del scroll */\n}\n\n.scrollable::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(100, 100, 100, 0.7); /* Color al pasar el cursor */\n}\n\n.scrollable::-webkit-scrollbar-track {\n    background: transparent; /* Fondo del track del scroll */\n}\n\n\n.dropdown-item {\n    color: #000000 !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
